import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";
const AppFooter = () => {
    return (
        <Paper variant="outlined" square sx={{paddingY: "2vh"}}>
            <Typography align="center" variant="overline" component="div" sx={{fontWeight: "bold"}}>
                ALL RIGHTS RESERVED
            </Typography>
        </Paper>
    )
}

export default AppFooter;